/**
 * @file Re-exports the ImpersonatedSourceConnect component.
 */
import ImpersonatedSourceConnect from "./ImpersonatedSourceConnect";

export default ImpersonatedSourceConnect;
